const BreadCrumpData = {
    Home: [{ pageName: "Home", pageURL: "/homepage" }],
    Punchout: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Punchout Catalog", pageURL: "/punchout" }],
    UserProfile: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "User Profile", pageURL: "/profile" }],
    TestPage: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "User Profile", pageURL: "/profile" }],
    AccessDenied: [],
    UnderConstruction: [],
    NonCatalog: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Non-Catalog Request", pageURL: "/" }],
    BinToBinTransfer: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Bin To Bin Transfer", pageURL: "/" }],
    ShoppingCart: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Shopping Cart", pageURL: "/" }],
    ItemDetail: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Item Details", pageURL: "/" }],
    SearchResults: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Search Result", pageURL: "/" }],
    UserProfile: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "UserProfile", pageURL: "/" }],
    FavoriteOrder: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Favorite Order Maintenance", pageURL: "/" }],
    ShopRedirect: [{ pageName: "Punchout Catalog", pageURL: "/Punchout" }],
    OrderApproval: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Waiting Order Approval", pageURL: "/" }],
    WaitingRequestorApproval: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Waiting Requestor Approval", pageURL: "/" }],
    RequestorApproval: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Waiting Requestor Approval", pageURL: "/needquote" }, { pageName: "Requestor Approval", pageURL: "/" }],
    Favorites: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Favorite Item Maintenance", pageURL: "/" }],
    Notifications: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Notification", pageURL: "/" }],
    OrderStatus: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Check Order Status", pageURL: "/" }],
    SupplierCallIn: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Supplier Call-In", pageURL: "/" }],
    Replen: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Replenish Review", pageURL: "/" }],
    ProductReplenishment: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Product Replenishment", pageURL: "/" }],
    InsiteonlineRMA: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Return to Inventory", pageURL: "/" }], //[10/11/23, CPW-160 Hamburger menu in MM app, Vishwa S]
    StockvalueReport: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Stock Value Report", pageURL: "/" }],
    CCReport: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Cycle Count Analysis", pageURL: "/" }],
    Recon: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Cycle Count Reconciliation", pageURL: "/" }],
    StockIssueReport: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "SDI Stock Issues Report", pageURL: "/" }],
    BinLabelPrint: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Bin Label Printing", pageURL: "/" }],
    ReceiveItems: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Receive Items", pageURL: "/" }],
    Pickup: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Picking Assign To", pageURL: "/" }],
    ASNApproval: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "ASNApproval", pageURL: "/" }],
    CycleCount: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Cycle Count", pageURL: "/" }],
    ExpressPutAway: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Express Put Away", pageURL: "/" }],
    //[1/20/22, PC_IH_04, WW-320, Dhevanesam R]
    ItemHolds: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "ItemHolds", pageURL: "/" }],
    DefaultPutAwayLocations: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Default PutAway Locations", pageURL: "/" }],
    TransactionReport: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Transaction Report", pageURL: "/" }],
    ReceivingReport: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Receiving Report", pageURL: "/" }],
    STKIssuesCart: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Stock Issue", pageURL: "/" }], //[10/11/23, CPW-160 Hamburger menu in MM app, Vishwa S]
    LoadStageError: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Load Stage and Putaway", pageURL: "/" }],
    ManageForms: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Manage Forms", pageURL: "/" }],
    InteractiveDiagram: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Interactive Diagram", pageURL: "/" }],
    LabelByLocation: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Labels by Location", pageURL: "/" }],
    AddForms: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Manage Forms", pageURL: "/manageforms" }, { pageName: "Add Forms", pageURL: "/" }],
    RTV: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "RTV", pageURL: "/" }],
    ReprintPackingSlipsComponent: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Reprint Packing And Ship Doc", pageURL: "/" }],
    RefSiteMaintenanceComponent: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "ReferenceSite Maintenance", pageURL: "/" }],
    MaterialStorageLoc: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Material Storage Locations", pageURL: "/" }],
    ItemMaintenance: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Add Stock Items", pageURL: "/" }],
    SrcNonCatalog: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Sourced Non-Catalog Entry", pageURL: "/" }],
    ManualStockAdjustment: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Manual Stock Adjustment", pageURL: "/" }],
    MobileInventoryManagement: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Mobile Inventory Management System", pageURL: "/" }],
    ReleaseNotesMaintenance: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Release Notes Maintenance", pageURL: "/" }],
    AddStockItems: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Add Stock Items", pageURL: "/" }],
    NonCatalogRequestEntry: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Non-Catalog Request", pageURL: "/" }],
    ContainerPacking: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Container Packing", pageURL: "/" }],
    POWorkbench: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "PO Workbench", pageURL: "/" }],//WW-1227 Added PO workbench in breadcrump
    FedexShipping: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "FedEx Shipping", pageURL: "/" }],//[Regression bug 5215 - Yuvarani K]
    Reconciliation: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Cycle Count Reconciliation", pageURL: "/" }],//[Regression bug 5328 - Yuvarani K]
    //WW-1216 Precart - Yuvarani K
    SupplierSuggestion: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Supplier Suggestion", pageURL: "/" }],
    Equipments: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Equipment", pageURL: "/" }],//WW-676 equipments S.Sanjay12/04/2024
    OpenPOReport: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Open POs", pageURL: "/" }],
    PrintContainerBarCodeLabels: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Print container bar code labels", pageURL: "/" }],
    TrackingNumber: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Tracking Number Update", pageURL: "/" }],
    FieldInventoryWorkBench: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Field Inventory Workbench", pageURL: "/" }],
    SupplierOrderEntry: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Walk-In", pageURL: "/" }],
    AcceptTransfer: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Accept Transfer", pageURL: "/" }],
    AddVersion: [{ pageName: "Home", pageURL: "/homepage" }, { pageName: "Release Notes Maintenance", pageURL: "/" }]
};


//WW-1282_WW-1278 - Declare the object SearchBreadCrumpData.
const SearchBreadCrumpData = {
    // 2. Have the array of object named as ItemDetail
    ItemDetail: {
        // 2.1 key SearchResults
        SearchResults: [
            { pageName: "Home", pageURL: "/homepage" },
            { pageName: "Search Result", pageURL: "/searchresults" },
            { pageName: "Item Details", pageURL: "/" }
        ],
        // 2.2 key ShoppingCart
        ShoppingCart: [
            { pageName: "Home", pageURL: "/homepage" },
            { pageName: "Shopping Cart", pageURL: "/shoppingcart" },
            { pageName: "Item Details", pageURL: "/" }
        ]
    },
    // 3. Have the object named as Forms
    Forms: {
        // 3.1 key SearchAndItem parameter search, itemDetail
        SearchAndItemDetail: [
            { pageName: "Home", pageURL: "/homepage" },
            { pageName: "Search Result", pageURL: "/searchresults" },
            { pageName: "Item Details", pageURL: "/itemdetailnew" },
            { pageName: "Form", pageURL: "/" }
        ],
        // 3.2 key ShoppingCart
        ShoppingCart: [
            { pageName: "Home", pageURL: "/homepage" },
            { pageName: "Shopping Cart", pageURL: "/shoppingcart" },
            { pageName: "Form", pageURL: "/" }
        ],
        // 3.3 key SearchResults parameter search
        SearchResults: [
            { pageName: "Home", pageURL: "/homepage" },
            { pageName: "Search Result", pageURL: "/searchresults" },
            { pageName: "Form", pageURL: "/" }
        ],
        // 3.4 key ItemDetail parameter itemDetail
        ItemDetail: [
            { pageName: "Home", pageURL: "/homepage" },
            { pageName: "Item Details", pageURL: "/itemdetailnew" },
            { pageName: "Form", pageURL: "/" }
        ]
    },
    // 4. Have the object key named as Supplier suggestion
    SupplierSuggestion: {
        // 4.1 key SearchAndItem parameter search, itemDetail
        SearchAndItemDetail: [
            { pageName: "Home", pageURL: "/homepage" },
            { pageName: "Search Result", pageURL: "/searchresults" },
            { pageName: "Item Details", pageURL: "/itemdetailnew" },
            { pageName: "Supplier Suggestion", pageURL: "/" }
        ],
        // 4.2 key SearchResults parameter search
        SearchResults: [
            { pageName: "Home", pageURL: "/homepage" },
            { pageName: "Search Result", pageURL: "/searchresults" },
            { pageName: "Supplier Suggestion", pageURL: "/" }
        ],
        // 4.3 key ItemDetail parameter itemDetail
        ItemDetail: [
            { pageName: "Home", pageURL: "/homepage" },
            { pageName: "Item Details", pageURL: "/itemdetailnew" },
            { pageName: "Supplier Suggestion", pageURL: "/" }
        ]
    }
};
// WW-1282_WW-1278- Export the SearchBreadCrumpData
export { BreadCrumpData, SearchBreadCrumpData };